
import type { PropType } from 'vue'
import type { InstanceManagementNavItem, InstanceManagementNavItemChild } from '../../models'
import { defineComponent } from 'vue'
import TransitionSize from '../transition-size.component.vue'

export default defineComponent({
  name: 'InstanceManagementNavbar',
  components: {
    TransitionSize,
  },
  props: {
    navItems: {
      type: Array as PropType<Array<InstanceManagementNavItem>>,
      required: true,
    },
    selectedNavItemId: {
      type: String,
    },
    selectedChildId: {
      type: String,
    },
    messages: {
      type: Object, // { disabled: string; }
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-instance-management-navbar',
    }
  },
  methods: {
    getNavItemClasses(navItem: InstanceManagementNavItem): (string | Record<string, boolean>)[] {
      const baseClass = `${this.baseClass}__nav-item`
      return [
        baseClass,
        {
          [`${baseClass}--selected`]: this.isNavItemSelected(navItem),
        },
      ]
    },
    isNavItemSelected(navItem: InstanceManagementNavItem): boolean {
      return navItem.id === this.selectedNavItemId
    },
    isChildSelected(child: InstanceManagementNavItemChild): boolean {
      return child.id === this.selectedChildId
    },
    hasNavItemChildren(navItem: InstanceManagementNavItem): boolean {
      return !!navItem.children?.length
    },
  },
})
